import React, { useContext } from "react";
import { LanguageContext, text } from "../../container/language";
import { buildURLForArticle, buildURLForCategory } from "../../utils/buildURL";
import Link from "../../utils/Link";

const SearchResult = ({ title, excerpt, uri, category, slug }) => {
  const { userLanguage } = useContext(LanguageContext);

  return (
    <li className="search-results__item">
      <div className="search-results__text">
        <p>
          <Link to={uri} className="search-results__title">
            <font>
              <font>{text(title, userLanguage)}</font>
            </font>
          </Link>
        </p>
        <p className="search-results__category">
          <font>
            <font>{category && text(category, userLanguage)}</font>
          </font>
        </p>
        <p>{text(excerpt, userLanguage)}</p>
      </div>
      <div className="search-results__preview"></div>
    </li>
  );
};

export default SearchResult;
